// @ts-nocheck legacy file transformed to TS
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { SVGIcon, Button } from 'ic-snacks'
import { FormattedMessage } from 'react-intl'

import { DashTooltip } from 'legacy/dash-blocks/dash-tooltip/DashTooltip'
import Spacer from 'legacy/components/Spacer'
import Modal from 'legacy/components/Modal'
import deprecatedAnalytics from 'legacy/common/deprecatedAnalytics'
import instacart from 'legacy/common/instacart'
import RegionLocationDropdown from 'legacy/components/RegionLocationDropdown'
import { copyToClipboard } from 'legacy/common/utils'
import FilterBar from 'legacy/components/FilterBar'
import { CatalogContext, withCatalogContext, withNotificationContext } from 'legacy/common/context'
import withRetailerRouter from 'legacy/common/withRouter'
import ApiResponseError from 'legacy/common/errors/ApiResponseError'
import { trackEvent } from 'utils/events/trackEvent'
import AisleVisibilityCTA from 'legacy/routes/catalog/departments/aisleVisibility/AisleVisibilityCTA'
import PrimaryProductsCheckbox from 'legacy/routes/catalog/departments/primaryProducts/PrimaryProductsCheckbox'
import { LegacyRetailerLocaleSelect } from './LegacyRetailerLocaleSelect'

const FlexContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: ${({ margin }) => margin || 0};
`

@withRetailerRouter
@withCatalogContext
@withNotificationContext
class AisleHeader extends Component<any> {
  /* eslint-disable react/forbid-prop-types */
  static propTypes = {
    history: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    query: PropTypes.object.isRequired,
    notify: PropTypes.func,
    onDelete: PropTypes.func.isRequired,
    notifyError: PropTypes.func,
    onEditClick: PropTypes.func.isRequired,
    aisle_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onlyPrimaryProducts: PropTypes.bool.isRequired,
    onToggleOnlyPrimaryProducts: PropTypes.func.isRequired,
    useMesh: PropTypes.bool,
  }
  /* eslint-enable react/forbid-prop-types */

  state = {
    confirmDeleteAisle: false,
  }

  handleAddProducts = () => {
    this.props.history.push({
      query: {
        ...this.props.query,
        addProducts: 'aisle',
      },
    })
  }

  handleShare = aisle => () => {
    if (!aisle) return

    const { name, share_link } = aisle
    trackEvent({
      id: 'catalog.products.aisles.copied_share_link',
      description: 'Clicked on share aisle button',
      data: {
        name,
        shareLink: share_link,
      },
    })
    copyToClipboard(share_link)
    this.props.notify(<FormattedMessage id="aisle.notification.share" values={{ name }} />)
  }

  handleConfirmDelete = () => {
    const {
      match: {
        params: { partner_id, warehouse_id, department_id, aisle_id },
      },
    } = this.props

    return instacart.go
      .delete(
        `/v1/partners/${partner_id}/warehouses/${warehouse_id}/departments/${department_id}/aisles/${aisle_id}`
      )
      .then(response => {
        this.setState({ confirmDeleteAisle: false })
        deprecatedAnalytics.track('catalog.aisle_delete_success')
        this.props.onDelete(aisle_id)

        return response
      })
      .catch(e => {
        if (e instanceof ApiResponseError && e.errors && e.errors.length) {
          this.props.notifyError(e.errors[0])
        } else {
          this.props.notifyError(<FormattedMessage id="aisle.delete.error" />)
        }
      })
  }

  handleDeleteAttempt = () => {
    this.setState({
      confirmDeleteAisle: true,
    })
  }

  handleCancelDelete = () => {
    this.setState({
      confirmDeleteAisle: false,
    })
  }

  handleEdit = () => {
    const {
      match: {
        params: { aisle_id },
      },
    } = this.props

    this.props.onEditClick(aisle_id)
  }

  renderDeleteConfirmation(aisle) {
    if (!this.state.confirmDeleteAisle || !aisle) {
      return null
    }

    return (
      <Modal width={500} height={300} isOpen onClose={this.handleCancelDelete}>
        {(Header, Body, Footer) => [
          <Header>
            <FormattedMessage id="aisle.delete.title" />
          </Header>,
          <Body style={{ padding: '40px' }}>
            <Body>
              <FormattedMessage
                id="aisle.delete.confirmation"
                values={{ productCount: aisle.product_count }}
              />
            </Body>
          </Body>,
          <Footer style={{ display: 'flex', justifyContent: 'center' }}>
            <Button snacksStyle="secondary" size="standard" onClick={this.handleCancelDelete}>
              <FormattedMessage id="cancel" />
            </Button>
            <Spacer width="30px" />
            <Button
              snacksStyle="primary"
              size="standard"
              onClick={this.handleConfirmDelete}
              elementAttributes={{ 'data-testid': 'confirm-delete-aisle-button' }}
            >
              <FormattedMessage id="delete" />
            </Button>
          </Footer>,
        ]}
      </Modal>
    )
  }

  render() {
    const { aisle_id, onToggleOnlyPrimaryProducts, onlyPrimaryProducts, useMesh } = this.props

    return (
      <CatalogContext.Consumer>
        {({ aisle, setAisleVisibility, handleAisleVisibilityModal, aisleVisibilityModalOpen }) => (
          <FilterBar padding="5px 15px" justifyContent="space-between">
            <FlexContainer>
              {<RegionLocationDropdown useInventoryAreas showRegions={!useMesh} />}
              {aisle_id && aisle && (
                <PrimaryProductsCheckbox
                  onToggle={onToggleOnlyPrimaryProducts}
                  isSelected={onlyPrimaryProducts}
                />
              )}

              <div css={{ width: 200 }}>
                <LegacyRetailerLocaleSelect />
              </div>
            </FlexContainer>
            {aisle_id && aisle && (
              <FlexContainer>
                <AisleVisibilityCTA
                  aisleName={aisle.name}
                  isAisleVisible={aisle.visible}
                  isModalOpen={aisleVisibilityModalOpen}
                  setAisleVisibility={() => setAisleVisibility(!aisle.visible)}
                  handleOpenModal={() => handleAisleVisibilityModal(true)}
                  handleCloseModal={() => handleAisleVisibilityModal(false)}
                  useMesh={useMesh}
                />
                <DashTooltip
                  target={
                    <Button
                      snacksStyle="flat"
                      size="small"
                      onClick={this.handleEdit}
                      icon={<SVGIcon name="pencil" />}
                      elementAttributes={{ 'data-testid': 'edit-aisle-button' }}
                    />
                  }
                >
                  <FormattedMessage id="aisles.tooltip.edit" />
                </DashTooltip>
                <DashTooltip
                  target={
                    <Button
                      snacksStyle="flat"
                      size="small"
                      icon={<SVGIcon name="share" />}
                      onClick={this.handleShare(aisle)}
                    />
                  }
                >
                  <FormattedMessage id="aisles.tooltip.share" />
                </DashTooltip>
                <DashTooltip
                  target={
                    <Button
                      snacksStyle="flat"
                      size="small"
                      icon={<SVGIcon name="delete" />}
                      onClick={this.handleDeleteAttempt}
                      elementAttributes={{ 'data-testid': 'delete-aisle-button' }}
                    />
                  }
                >
                  <FormattedMessage id="aisles.tooltip.delete" />
                </DashTooltip>
                <Button snacksStyle="primary" size="small" onClick={this.handleAddProducts}>
                  <FormattedMessage id="aisles.addProducts" />
                </Button>
              </FlexContainer>
            )}
            {this.renderDeleteConfirmation(aisle)}
          </FilterBar>
        )}
      </CatalogContext.Consumer>
    )
  }
}

export default AisleHeader
